import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiUrlProvider } from "./api-url.provider";
import { IEmployeeTrainingRecord } from "../shared/models/employee-training-record";
import { IApiResult } from "../shared/models/api-result";
import { Observable } from "rxjs";
import { IEmployeeTrainingRecordEntity } from "../shared/models/employee-training-record-entity";

@Injectable({
  providedIn: "root"
})
export class EmployeeTrainingRecordService{
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IEmployeeTrainingRecord[]>>{
    return this.http.get<IApiResult<IEmployeeTrainingRecord[]>>(`${this.apiUrlProvider.url}/EmployeeTrainingRecord`);
  }

  getEmployeeTrainingRecords(employeeId: number): Observable<IApiResult<IEmployeeTrainingRecord[]>>{
    return this.http.get<IApiResult<IEmployeeTrainingRecord[]>>(`${this.apiUrlProvider.url}/EmployeeTrainingRecord/${employeeId}`);
  }

  getTrainingRecordInPast6Month(employeeId: number): Observable<IApiResult<IEmployeeTrainingRecord[]>>{
    return this.http.get<IApiResult<IEmployeeTrainingRecord[]>>(`${this.apiUrlProvider.url}/EmployeeTrainingRecord/${employeeId}/past6month`);
  }

  getEmployeeTrainingRecordEntities(): Observable<IApiResult<IEmployeeTrainingRecordEntity>>{
    return this.http.get<IApiResult<IEmployeeTrainingRecordEntity>>(`${this.apiUrlProvider.url}/EmployeeTrainingRecord/entities`);
  }  

  add(entity: IEmployeeTrainingRecord): Observable<IApiResult<IEmployeeTrainingRecord>>{
    return this.http.post<IApiResult<IEmployeeTrainingRecord>>(`${this.apiUrlProvider.url}/EmployeeTrainingRecord`, entity);
  }

  update(entity: IEmployeeTrainingRecord): Observable<IApiResult<IEmployeeTrainingRecord>>{
    return this.http.post<IApiResult<IEmployeeTrainingRecord>>(`${this.apiUrlProvider.url}/EmployeeTrainingRecord/${entity.id}/update`, entity);
  }

  delete(entityId: number): Observable<IApiResult<boolean>>{
    return this.http.post<IApiResult<boolean>>(`${this.apiUrlProvider.url}/EmployeeTrainingRecord/${entityId}/delete`, null);
  }  
}